module.exports = __webpack_public_path__ + "officialStatic/img/made2.b1c2352.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/made2.jpg
// module id = h9YL
// module chunks = 0